const websiteContactApiUrl = process.env.WEBSITE_CONTACT_API_URL;

export function activeCampaignAddContact({
    fullName, email, desiredPosition, phone, comments, jobTitle,
    formId, contactUrl, ref, prevSite, source, medium, device, company,
    captchaResponse, gdpr2019, suscription
}) {
    return new Promise((resolve, reject) => {
        var data = {
            name: fullName,
            desiredposition: desiredPosition,
            jobtitle: jobTitle,
            company,
            email,
            phone,
            comments,
            form: formId,
            url: contactUrl,
            ref: ref,
            prevsite: prevSite,
            source: source,
            medium: medium,
            device,
            captcharesponse: captchaResponse,
            gdpr2019: gdpr2019,
            suscription: suscription
        };
        $.ajax({
            type: "POST",
            url: `${websiteContactApiUrl}/activecampaign-add-update-contact`,
            data: JSON.stringify(data),
            contentType: "application/json",
            success: function (res) {
                if (res.errorMessage) reject(res.errorMessage);
                else resolve();
            },
            error: reject,
        });
    })
}